import React from 'react';

import { BonusIdentifier } from 'constants/appEnums';
import ActiveContainer from 'theme/assets/images/bonus-active.svg';
import InactiveContainer from 'theme/assets/images/bonus-inactive.svg';

import { ReactComponent as DecisionTime } from 'theme/assets/images/bonuses/decision-time.svg';
import { ReactComponent as NewSigning } from 'theme/assets/images/bonuses/new-signing.svg';

import './BonusIcon.scss';

type ReactSVG = React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined;
  }
>;

const icons: Map<string, ReactSVG> = new Map([
  [BonusIdentifier.NewSigning, NewSigning],
  [BonusIdentifier.DecisionTime, DecisionTime]
]);

export interface IBonusIconProps {
  icon: string;
  active: boolean;
  className?: string;
}

const BonusIcon = (props: IBonusIconProps) => {
  const container: string = props.active ? ActiveContainer : InactiveContainer;
  const IconComponent: ReactSVG | undefined = icons.get(props.icon);

  return (
    <div className={`bonus-icon__container ${props.className ?? ''}`} style={{ backgroundImage: `url(${container})` }} data-testid="bonus-icon">
      {IconComponent && <IconComponent className="bonus-icon__image" />}
    </div>
  );
};

export default BonusIcon;
